// extracted by mini-css-extract-plugin
export default {"player":"video_modal_player__+iyvM"};